import {
  getVideoPayload,
  getLinkClickPayload,
  getPhonePayload,
  getSignupPayload,
  getEngageStartPayload,
  getEngageCompletePayload,
} from "./analytics";

module.exports = {
  "header-link-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.link.click",
    payload: getLinkClickPayload(currentPage, node, { location: "header" }),
  }),
  "footer-link-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.link.click",
    payload: getLinkClickPayload(currentPage, node, { location: "footer" }),
  }),
  "header-phone-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.link.click",
    payload: getPhonePayload(currentPage, node),
  }),
  "signup-link-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.engage.sign_up",
    payload: getSignupPayload(currentPage, node),
  }),
  "engage-link-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.engage.start",
    payload: getEngageStartPayload(currentPage, node),
  }),
  "body-link-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.link.click",
    payload: getLinkClickPayload(currentPage, node, { location: "body" }),
  }),
  "video-click": (currentPage, node) => ({
    eventType: "click",
    eventName: "public_web.page.video.click",
    payload: getVideoPayload(currentPage, node),
  }),
};



// WEBPACK FOOTER //
// ./src/pages/helpers/analyticsHandlers.js